// extracted by mini-css-extract-plugin
export default {"headerContainer":"oGd4Ok","headerTitle":"QImeDy","headerBalance":"oEanF6","headerLimitlessBalance":"xOOqc3","headerIconContainer":"dp5Iwy"};